import React, { useEffect, useState } from "react";
import { useEventContext } from "../../context/EventContext";
import { useStreamContext } from "../../context/StreamContext";
import { motion, AnimatePresence } from "framer-motion";
import "./style.scss";
import { eventBannerClick } from "../../utils/api";

export default ({ block }) => {
    const { event } = useEventContext();
    const { stream } = useStreamContext();

    const [banners, setBanners] = useState([]);
    const [currentBanner, setCurrentBanner] = useState(0);

    useEffect(() => {
        if (Array.isArray(event?.banner) && event.banner.length) {
            const skipDisplay = block?.skipDisplay || [];
            const targetStreams = block?.targetStreams || {};
            const displayedBanners = event.banner.filter((banner) =>
                banner.file &&
                !skipDisplay.includes(String(banner.id)) &&
                (!stream || !targetStreams[banner.id]?.length || targetStreams[banner.id]?.includes(String(stream.id))));
            setBanners(displayedBanners)
        }
    }, [event, block, stream]);

    useEffect(() => {
        let timeout;
        clearTimeout(timeout);
        if (banners.length < 2) {
            return
        }
        timeout = setTimeout(() => {
            updateCurrentBanner();
        }, banners[currentBanner]?.timeout * 1000)

        return () => clearTimeout(timeout);
    }, [currentBanner, banners]);

    const updateCurrentBanner = () => {
        let newIndex = currentBanner + 1;
        if (newIndex >= banners.length) {
            newIndex = 0;
        }
        setCurrentBanner(newIndex);
    }

    const handleClick = async () => {
        if (!banners[currentBanner]?.link) return;

        try {
            await eventBannerClick(banners[currentBanner].id);
        } catch (e) {
            console.error(e)
        }
    }

    return (
        !!banners.length && <section className="page-block banner-block">
            <a className="banner-container" href={banners[currentBanner]?.link} target="_blank" onClick={handleClick} >
                <AnimatePresence initial={false}>
                    <motion.img
                        key={currentBanner}
                        src={banners[currentBanner]?.url}
                        initial={{
                            x: 1000,
                            y: "-50%",
                            opacity: 0,
                        }}
                        animate={{
                            zIndex: 1,
                            x: 0,
                            y: "-50%",
                            opacity: 1,
                        }}
                        exit={{
                            zIndex: 0,
                            x: -1000,
                            y: "-50%",
                            opacity: 0,
                        }}
                        transition={{
                            x: { type: "spring", stiffness: 300, damping: 30 },
                            opacity: { duration: 0.8 },
                        }}
                    />
                </AnimatePresence>
            </a>
        </section>
    )
}